import { useMemo } from 'react';
import classNames from 'classnames';

import TBBBlueRegister from '../../../../images/tbb-blue-register.png';
import TrashiCoinLogo from '../../../../images/trashie-logo.webp';
import { Button, BUTTON_SIZE, BUTTON_TYPE } from '../../../../global/Button';
import {
  getNextButtonStyles,
  isBoxRecyclingProductType,
  isTextilRecyclingProductType,
} from '../../../../utils/tbbRegistration';

import './Welcome.scss';

const Welcome = ({
  handleOnClick,
  storeConfig,
  recyclingProductType,
  stepTrackerProps,
  isValidCode,
}) => {
  const {
    isTrashie: isTrashieStore,
    mainLogoSrc,
    registerTbbFlow,
  } = useMemo(() => storeConfig, [storeConfig]);

  const isTextilRecycling = isTextilRecyclingProductType(recyclingProductType);

  const isTrashie = useMemo(() => (
    isTrashieStore || !mainLogoSrc
  ), [isTrashieStore, mainLogoSrc]);

  const storeLogo = useMemo(
    () => {
      if (isTrashie || !isValidCode) {
        return TrashiCoinLogo;
      }
      return mainLogoSrc;
    },
    [isTrashie, mainLogoSrc, isValidCode],
  );

  return (
    <div className="RegisterWelcome">
      {((isTrashie && isTextilRecycling) || !isValidCode) && (
        <div className="RegisterWelcome__image">
          <img
            src={TBBBlueRegister}
            alt="The take back bag"
          />
        </div>
      )}
      <div className={classNames('RegisterWelcome__logo', { 'is-trashie': isTrashie })}>
        <img
          src={storeLogo}
          alt="store logo"
          style={registerTbbFlow?.landingPageStep?.logoStyleProperties}
        />
      </div>
      <div className="RegisterWelcome__text" style={registerTbbFlow?.landingPageStep?.descriptionStyleProperties}>
        {registerTbbFlow?.landingPageStep?.description || (
          (
            isBoxRecyclingProductType(recyclingProductType)
          ) ? (
            <>
              REGISTER YOUR TECH TAKE
              <br />
              BACK BOX AND GET REWARDS
            </>
            ) : (
              <>
                REGISTER YOUR TAKE BACK BAG
                <br />
                AND GET REWARDS
              </>
            )
        )}
      </div>
      <Button
        type={BUTTON_TYPE.QUATERNARY}
        size={BUTTON_SIZE.LARGE}
        onClick={handleOnClick}
        style={getNextButtonStyles(storeConfig)}
        trackerProps={stepTrackerProps}
      >
        {registerTbbFlow?.landingPageStep?.button?.text ?? 'GET STARTED'}
      </Button>
    </div>
  );
};

export default Welcome;
